(async () => {
    const { Core } = await importModule('Core');
    const { fetchHTML, debounce, $show, $replaceContent } = await importModule('Utils');

    const ATTR_ONLY_STOCK = 'only-stock-products';
    const ATTR_MIN_CHARS = 'min-chars';
    const ATTR_LIMIT = 'results-limit';
    const ATTR_SOURCES = 'sources';
    const RQ_SECTION = 'r_predictive-search';
    const RQ_SECTION_SELECTOR = `[data-content]`;
    const RQ_SECTION_NO_RESULTS = '[data-no-results]'
    const DEFAULT_MIN_CHARS = 3;
    const DEFAULT_LIMIT = 5;
    const CN_ACTIVE = '!active';
    
    customElements.define('predictive-search-input', class extends Core {
        elements = {
            input: 'input[name="q"]',
            results: '[data-results]',
            wrapper: '[data-wrapper]'
        }
        
        render() {
            this._disableAutocomplete();
            this._handleInput();
            this._handleOuterClick();
            // this.addEventListener('click', () => console.log('clicked'));
        }

        _disableAutocomplete() {
            this.$input.setAttribute('autocomplete', 'off');
        }

        _handleInput() {
            this.$input.addEventListener('focus', this._handleFocus.bind(this));
            this.$input.addEventListener('blur', this._handleBlur.bind(this));
            this.$input.addEventListener('input',  debounce(this._inputHandler.bind(this), 300).bind(this));
        }

        _handleFocus() {
            this.active = this.hasResults;
            this.lights = false;
        }

        _handleBlur(e) {
            this.lights = true;
        }

        _handleOuterClick() {
            document.addEventListener('click', (e) => {
                if(!this.contains(e.target) && this.active) {
                    this.active = false;
                }
            })
        }

        async _inputHandler() {
            if(!this.minQueryChars) {
                this.hasResults = false;
                return;
            }
            
            this.resultsDoc = await this._fetchResultsDoc();
        }

        _fetchResultsDoc() {
            return fetchHTML(`${routes.predictive_search_url}?${this.searchParams}`);
        }

        _updateResults($newResults) {
            $replaceContent(
                this.$results,
                $newResults
            )
        }

        set resultsDoc(doc) {
            if(doc.querySelector(RQ_SECTION_NO_RESULTS)) {
                this.hasResults = false;
                return;
            }

            this.hasResults = true;
            this._updateResults(
                doc.querySelector(RQ_SECTION_SELECTOR)
            );
        }

        set active(state) {
            this.$wrapper
                .classList
                .toggle(CN_ACTIVE, state);

            this._active = state;
        }


        get active() {
            return !!this._active;
        }

        get lights() {
            return this._lights;
        }

        set lights(state) {
            this.publish('lights-out', !state);
            this._lights = state;
        }

        set hasResults(state) {
            if(this.active !== state) {
                this.active = state;
            }

            return this._hasResults = state;
        }

        get hasResults() {
            return !!this._hasResults;
        }

        get minQueryChars() {
            return this.query.length >= this.minChars;
        }

        get query() {
            return this.$input.value.trim();
        }

        get minChars() {
            return this.hasAttribute(ATTR_MIN_CHARS) 
                ? this.getAttribute(ATTR_MIN_CHARS) 
                : DEFAULT_MIN_CHARS;
        }

        get searchParams() {
            return new URLSearchParams({
                q: this.query,
                'resources[type]': `${this.sources}${this.onlyStock}`,
                'resources[limit]': this.limit,
                'section_id': RQ_SECTION
            }).toString();
        }
        
        get sources() {
            return this.hasAttribute(ATTR_SOURCES) 
                ? this.getAttribute(ATTR_SOURCES).split(',').filter(Boolean).join(',')
                : '';
        }

        get onlyStock() {
            return this.hasAttribute(ATTR_ONLY_STOCK) 
                ? 'resources[options][unavailable_products]=hide' 
                : '';
        }
        
        get limit() {
            return this.hasAttribute(ATTR_LIMIT) 
                ? this.getAttribute(ATTR_LIMIT)
                : DEFAULT_LIMIT;
        }
    })
})();
